import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  isOver: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  dropZone: {
    border: '0.25rem solid transparent',
    boxSizing: 'border-box',
    height: '1rem'
  },

  dropZoneTop: {
    borderBottomColor: 'gainsboro'
  },

  dropZoneMiddle: {
    borderTopColor: 'gainsboro',
    borderBottomColor: 'gainsboro'
  },

  dropZoneBottom: {
    borderTopColor: 'gainsboro'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid silver',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    padding: '1rem',
    backgroundColor: 'white'
  },

  last: {
    marginBottom: '0'
  },

  title: {
    display: 'flex',
    alignItems: 'center'
  },

  dragHandle: {
    display: 'flex',
    alignItems: 'center'
  },

  dragIcon: {
    marginRight: '0.5rem',
    cursor: 'pointer'
  },

  name: {
    width: 'calc(100% - 2rem)',
    fontSize: theme.size.base,
    outline: 'none',
    border: 'none'
  },

  closeIcon: {
    cursor: 'pointer'
  },

  descriptionArea: {
    display: 'flex',
    flexDirection: 'column'
  },

  label: {
    margin: '1rem 0 0.5rem 0',
    color: 'lightgrey'
  },

  description: {
    outline: 'none',
    border: 'none',
    resize: 'none',
    height: 'unset',
    maxHeight: '200px',
    fontSize: theme.size.base
  },

  fieldsDropbox: {
    display: 'grid',
    placeItems: 'center',
    border: ({ isOver }) => `2px dashed ${isOver ? 'dimgrey' : 'gainsboro'}`,
    borderRadius: '1rem',
    boxSizing: 'border-box',
    color: ({ isOver }) => (isOver ? 'dimgrey' : 'gainsboro'),
    transition: 'all 200ms'
  },

  noFields: {
    flex: '1',
    marginTop: '1rem',
    minHeight: '150px'
  },

  fields: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '-0.5rem'
  },

  addFields: {
    minHeight: '75px'
  }
}))

export default useStyles
